import { toast } from "react-toastify";

export const copyLinkHandler = async (referCode) => {
    if(!referCode) {
        return;
    }

    try {
        const referLink = `https://feedants.com/#/referral/${referCode}`;
        await navigator.clipboard.writeText(referLink)
        toast.success("Link copied to clipboard!");
    } catch(error) {
        console.error(error)
        toast.error("There was error while copying to clipboard!");
    }
}

export const referNowHandler = async (referCode) => {
    if(!referCode) {
        return;
    }
    try {
        const shareData = {
            title: "Feedants Referral Link!",
            text: "👋 Hi! I’m inviting you to join Feedants 🎶💃🎤\n\n" +
            "A global stage for singing, dancing, fitness, poetry, music & more competitions!\n\n" +
            "🎁 Get 15% OFF on your first purchase and 20% OFF on your next purchase — just by joining with my referral!\n\n" +
            "✅ Plus, my referral also supports prize pools for competitions on Feedants ✨\n\n" +
            `Use my code 👉 ${referCode.toUpperCase()}\n` +
            "Or tap the link to join now 👇\n" +
            `https://feedants.com/#/referral/${referCode.toUpperCase()}`,
            // url: `https://feedants.com/#/referral/${referCode.toUpperCase()}`
        };
        if (navigator.canShare && navigator.canShare(shareData)) {
            await navigator.share(shareData);
        } else {
            toast.error("Your browser doesn't support sharing custom message");
        }
    } catch (error) {
        console.error("Error in openShareDialogAsync"+JSON.stringify(error));
        toast.error(error.message);
    }
};